export default __webpack_public_path__ + "static/media/11 (1).8b34336f.jpg";